import React, { useEffect, useState } from "react";

const formatTime = (value) => String(Math.max(0, value)).padStart(2, "0");

const CountdownTimer = ({ initialTime = 22, isActive = true }) => {
  const [timeLeft, setTimeLeft] = useState(Math.max(0, Number(initialTime || 0)));

  useEffect(() => {
    setTimeLeft(Math.max(0, Number(initialTime || 0)));
  }, [initialTime]);

  useEffect(() => {
    if (!isActive || timeLeft <= 0) {
      return undefined;
    }

    const timerId = window.setInterval(() => {
      setTimeLeft((current) => Math.max(0, current - 1));
    }, 1000);

    return () => window.clearInterval(timerId);
  }, [isActive, timeLeft]);

  return <span>{`00:00:${formatTime(timeLeft)}`}</span>;
};

export default CountdownTimer;
